// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgOrderPackageIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M11 21.958v-9.413l-8.203-4.72v8.108q0 .622.301 1.138.302.517.836.826zm2 0 7.066-4.06a2.27 2.27 0 0 0 .836-.827q.3-.516.301-1.138v-8.12L13 12.539v9.42Zm4.065-14.06 3.045-1.773-6.973-4.005A2.23 2.23 0 0 0 12 1.809q-.603 0-1.137.31L8.934 3.222l8.13 4.676Zm-5.071 2.922 3.059-1.748-8.105-4.701-3.09 1.779z" />
  </g>
);
export default SvgOrderPackageIcon;
SvgOrderPackageIcon.displayName = 'SvgOrderPackageIcon';
